//  // src/api/search/searchApi.js
// import axiosClient from '../axiosClient';

// export const searchAll = async (query) => {
//     console.log('\n=== SEARCH API ===');
//     console.log('🔍 Query:', query);

//     try {
//         const data = await axiosClient.get(`/search?query=${encodeURIComponent(query)}`);
        
//         console.log('✅ Search results:', data?.length, 'items');
//         console.log('=== SEARCH API COMPLETE ===\n');
        
//         return data; // ← axiosClient already returns response.data, so this IS the array
//     } catch (error) {
//         console.error('❌ Search API error:', error);
//         throw error;
//     }
// };

// src/api/search/searchApi.js
import axiosClient from '../axiosClient';

export const searchAll = async (query) => {
    console.log('\n=== SEARCH API ===');
    console.log('🔍 Query:', query);

    try {
        const data = await axiosClient.get(`/search?query=${encodeURIComponent(query)}`);
        console.log('✅ Search results:', data?.length, 'items');
        console.log('=== SEARCH API COMPLETE ===\n');
        return data;
    } catch (error) {
        console.error('❌ Search API error:', error);
        throw error;
    }
};

export const getLineItems = async (docNum, category) => {
    console.log('\n=== LINE ITEMS API ===');
    console.log('📄 DocNum:', docNum, '| Category:', category);

    try {
        const data = await axiosClient.get(
            `/search/line-items?docNum=${docNum}&category=${encodeURIComponent(category)}`
        );
        console.log('✅ Line items:', data?.length, 'items');
        console.log('=== LINE ITEMS API COMPLETE ===\n');
        return data;
    } catch (error) {
        console.error('❌ Line items API error:', error);
        throw error;
    }
};